module.exports = "/images/logo.png?55ff4ab2ab908e41692c1b891d632aec";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo.png
// module id = AtYS
// module chunks = 5